import { memo } from 'react';

import type { ApiNotification } from '@izimi/api';

import { NotificationSharedItemAction } from './NotificationSharedItemAction';

type NavigateTo = '/sharing/to-you' | '/vault';

interface Props {
  notification: ApiNotification;
  navigateTo: NavigateTo;
}

export const CitizenDocumentsReceivedActions = memo(({ notification, navigateTo }: Props) => (
  <NotificationSharedItemAction notification={notification} targetPath={navigateTo} />
));
